import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      es: {
        translation: es
      },
      it: {
        translation: it
      }
    },
    lng: 'es', // default language
    fallbackLng: 'es',
    
    interpolation: {
      escapeValue: false // react already does escaping
    }
  });

export default i18n;